const removeEmpty = (data) => {
    const remove = (filter) => {
        const filters = filter.filters.map((filter) => {
            if (filter.hasOwnProperty('filters')) {
                const f = remove(filter);
                if (f && f.hasOwnProperty('filters') && !f.filters.length) {
                    return null;
                } else {
                    return f;
                }
            } else {
                return filter;
            }
        }).filter((filter) => !!filter);
        if (!filters.length) {
            return null;
        } else {
            return {...filter, filters};
        }
    }
    return remove(data)
}
export default removeEmpty;